import ActionsForm from '@/shared/mixins/actionsForm'
import CommissionRepository from '@/shared/http/repositories/realestate/commission'
import localStoreHelper from '@/shared/utils/localStoreHelper.js'
export default{
  mixins: [ActionsForm],
  name: 'tableSales',

  data () {
    return {
      consultacomissao: [],
      selectedComissao: {},
      filterOn: false,
      filter: localStoreHelper.imobiliaria.consultaVendas() || []

    }
  },
  methods: {
    onLoad () {
      if (localStoreHelper.imobiliaria.consultaVendas() != null) {
        this.searching(this.filter)
      }
      if (this.filterOn === false) {
        CommissionRepository.GetAll(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then(Response => {
            this.consultacomissao = Response.data.data
            this.$refs.tableGrid.LoadAllByData(Response)
          })
          .catch(() => {})
      } else {
        this.searching(this.filter)
      }
    },
    searchWithFilter (newCommissionArray, newResponse) {
      this.consultacomissao = newCommissionArray
      this.$refs.tableGrid.LoadAllByData(newResponse)
    },
    searching (search) {
      this.$refs.tableGrid.pagingIndex = 1
      this.filter = search
      this.filterOn = true
      CommissionRepository.GetComissaoByFiltro(this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex, search)
        .then(res => {
          if (res.status === 200) {
            this.consultacomissao = res.data.data
            this.$refs.tableGrid.LoadAllByData(res)
          }
        })
        .catch(() => {})
    },
    disableFilter () {
      this.$refs.tableGrid.pagingIndex = 1
      this.filterOn = false
      this.onLoad()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/salesinquiry/components/tableSales/tableSales.js